import React from 'react';
import { Link } from 'react-router-dom';
import { Rocket, ArrowRight } from 'lucide-react';
import { useSetupStatus } from '../hooks/useSetupStatus';
import '../pages/SetupWizardPage.css';

/**
 * «Готовность склада» (облако): полоска на домашнем экране администратора, пока
 * мастер первого запуска не завершён (пропущен кнопкой «Открыть систему»).
 * Ведёт в мастер и на «С чего начать». В режиме фокуса не нужна — там мастер
 * целиком (SetupGate). Full-Fix: сервер отвечает enabled=false — ничего не рисуем.
 */
export default function SetupChecklist({ enabled, isHome }) {
  const { st } = useSetupStatus(!!enabled && !!isHome);
  if (!enabled || !isHome || !st || !st.enabled || st.done || st.focus) return null;
  const pct = st.progress.total ? Math.round((100 * st.progress.done) / st.progress.total) : 0;
  const next = (st.steps || []).find((s) => s.state === 'todo');
  return (
    <section className="sw-check" aria-label="Готовность склада">
      <span className="sw-check__icon"><Rocket size={18} aria-hidden="true" /></span>
      <div className="sw-check__main">
        <p className="sw-check__title">Настройка склада — {st.progress.done} из {st.progress.total}</p>
        <span className="sw-check__bar"><span style={{ width: `${pct}%` }} /></span>
        {next && <p className="sw-check__next">Следующий шаг: {next.title}</p>}
      </div>
      <div className="sw-check__actions">
        <Link to="/start" className="ui-btn ui-btn--ghost ui-btn--sm">С чего начать</Link>
        <Link to={next ? `/setup?step=${next.key}` : '/setup'} className="ui-btn ui-btn--primary ui-btn--sm">
          Продолжить настройку <ArrowRight size={14} aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}
